"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitDelayedPropertyAnnexRequest = exports.submitPropertyAnnexRequest = exports.submitDelayedPropertyCutOffRequest = exports.submitPropertyCutOffRequest = exports.submitOwnerShipChangeRequest = exports.submitBCSValuation = exports.validateBCSTabuService = exports.getTabuParticipant = exports.cancelProcedure = exports.completeTabuProcedure = exports.getSiteMap = exports.getZajelAreasLookup = exports.getIssueCertificateLookup = exports.getLookup = exports.validateTabuService = exports.getTabuVoucher = exports.getProcedureDetails = exports.getRequests = exports.uploadTabuDocument = exports.saveConvertToFreeholdProcedure = exports.saveLossCertificate = exports.saveInternalPropertyEvaluation = exports.savePropertyEvaluation = exports.getPropertyEvaluationInfo = exports.saveSitePlan = exports.getElectronicTitleDeed = exports.saveTWIMCForProperty = exports.saveTWIMC = void 0;
var rest_1 = require("@eres/rest");
var config_1 = __importDefault(require("../config"));
var base_64_1 = __importDefault(require("base-64"));
var buffer_1 = require("buffer");
var utils_1 = require("./utils");
function saveTWIMC(request) {
    return (0, rest_1.httpPost)(config_1.default.tabuAPI().endPoint() + "tabu/SaveToWhomConcern", request);
}
exports.saveTWIMC = saveTWIMC;
function saveTWIMCForProperty(request) {
    return (0, rest_1.httpPost)(config_1.default.tabuAPI().endPoint() + "tabu/SavePropertPropertyDetailCertificate", request);
}
exports.saveTWIMCForProperty = saveTWIMCForProperty;
function getElectronicTitleDeed(participantId, propertyId, email) {
    return (0, rest_1.httpGet)(config_1.default.tabuAPI().endPoint() + "tabu/GetPropertyTitleDeed?email=" + email +
        "&participantId=" + participantId + "&propertyId=" + propertyId);
}
exports.getElectronicTitleDeed = getElectronicTitleDeed;
function saveSitePlan(request) {
    return (0, rest_1.httpPost)(config_1.default.tabuAPI().endPoint() + "tabu/SaveAffectionPlan", request);
}
exports.saveSitePlan = saveSitePlan;
function getPropertyEvaluationInfo(request) {
    return (0, rest_1.httpPost)(config_1.default.tabuAPI().endPoint() + "tabu/GetPropertyEvaluationInfo", request);
}
exports.getPropertyEvaluationInfo = getPropertyEvaluationInfo;
function savePropertyEvaluation(request) {
    return (0, rest_1.httpPost)(config_1.default.tabuAPI().endPoint() + "tabu/SavePropertyEvaluation", request);
}
exports.savePropertyEvaluation = savePropertyEvaluation;
function saveInternalPropertyEvaluation(request) {
    return (0, rest_1.httpPost)(config_1.default.tabuAPI().endPoint() + "tabu/SavePropertyInternalEvaluation", request);
}
exports.saveInternalPropertyEvaluation = saveInternalPropertyEvaluation;
function saveLossCertificate(request) {
    return (0, rest_1.httpPost)(config_1.default.tabuAPI().endPoint() + "tabu/SaveLossCertificate", request);
}
exports.saveLossCertificate = saveLossCertificate;
function saveConvertToFreeholdProcedure(request) {
    return (0, rest_1.httpPost)(config_1.default.tabuAPI().endPoint() + "tabu/SaveConvertToFreeholdProcedure", request);
}
exports.saveConvertToFreeholdProcedure = saveConvertToFreeholdProcedure;
function uploadTabuDocument(base64data, type) {
    var data = base64ToArrayBuffer(base64data);
    return (0, rest_1.httpPost)(config_1.default.tabuAPI().endPoint() + "Upload/UploadDocument?extension=" + type, data, { "Content-Type": "application/octet-stream" })
        .then(function (x) {
        if (x.FileName) {
            return {
                Code: 0,
                Message: "OK",
                Response: x,
            };
        }
        else {
            var error = new Error("Upload failed");
            error.response = x;
            throw error;
        }
    });
}
exports.uploadTabuDocument = uploadTabuDocument;
function getRequests(participantID, procedureId) {
    return (0, rest_1.httpGet)(config_1.default.tabuAPI().endPoint() + "tabu/GetRequestsByParticipant?ParticipantId=" + participantID)
        .then(function (x) {
        if (procedureId && x.Response) {
            var o = x.Response;
            x.Response = o.filter((0, utils_1.HistoryProcedureIdFilter)(procedureId));
        }
        return x;
    });
}
exports.getRequests = getRequests;
function getProcedureDetails(ProcedureNumber, ProcedureYear, ProcedureId) {
    var encoded = buffer_1.Buffer.from(ProcedureId + "-" + ProcedureYear + "-" + ProcedureNumber, "utf-8").toString("base64");
    return (0, rest_1.httpGet)(config_1.default.tabuAPI().endPoint() + "tabu/GetTabuRequestDetails?refNumber=" + encoded);
}
exports.getProcedureDetails = getProcedureDetails;
function getTabuVoucher(ProcedureNumber, ProcedureYear, ProcedureId) {
    return (0, rest_1.httpGet)(config_1.default.tabuAPI().endPoint() + "tabu/GetVoucher?procedureNumber=" +
        (ProcedureNumber + "&procedureYear=" + ProcedureYear + "&procedureId=" + ProcedureId));
}
exports.getTabuVoucher = getTabuVoucher;
function validateTabuService(validateRequest) {
    return (0, rest_1.httpPost)(config_1.default.tabuAPI().endPoint() + "tabu/ValidateProperty", validateRequest);
}
exports.validateTabuService = validateTabuService;
function getLookup(lookUpName, propertyId) {
    return (0, rest_1.httpGet)(config_1.default.tabuAPI().endPoint() + ("lookup/GetLookup?name=" + lookUpName) +
        (propertyId ? "&propertyId=" + propertyId : ""));
}
exports.getLookup = getLookup;
function getIssueCertificateLookup(propertyId) {
    return getLookup("issueCertificateType", propertyId);
}
exports.getIssueCertificateLookup = getIssueCertificateLookup;
function getZajelAreasLookup(emirateId) {
    return getLookup("zajelareas", emirateId);
}
exports.getZajelAreasLookup = getZajelAreasLookup;
function getSiteMap(propertyId) {
    return (0, rest_1.httpGet)(config_1.default.tabuAPI().endPoint() + "tabu/GetSiteMap?propertyid=" + propertyId);
}
exports.getSiteMap = getSiteMap;
function completeTabuProcedure(ProcedureId, ProcedureYear, ProcedureNumber, ref) {
    return (0, rest_1.httpGet)(config_1.default.tabuAPI().endPoint() + "tabu/CompleteProcedure?procedureNumber=" +
        (ProcedureNumber + "&procedureYear=" + ProcedureYear + "&paymentRefNumber=" + ref + "&procedureId=" + ProcedureId));
}
exports.completeTabuProcedure = completeTabuProcedure;
function cancelProcedure(ProcedureId, ProcedureYear, ProcedureNumber) {
    return (0, rest_1.httpGet)(config_1.default.tabuAPI().endPoint() + "tabu/CancelProcedure?procedureNumber=" +
        ProcedureNumber + "&procedureYear=" + ProcedureYear + "&procedureId=" + ProcedureId);
}
exports.cancelProcedure = cancelProcedure;
function getTabuParticipant(participantID) {
    return (0, rest_1.httpGet)(config_1.default.tabuSmartAPI().endPoint() + ("participant/" + participantID));
}
exports.getTabuParticipant = getTabuParticipant;
function validateBCSTabuService(validateRequest) {
    return (0, rest_1.httpPost)(config_1.default.tabuAPI().endPoint() + "tabu/ValidateBCSValuation", validateRequest);
}
exports.validateBCSTabuService = validateBCSTabuService;
function submitBCSValuation(request) {
    return (0, rest_1.httpPost)(config_1.default.tabuAPI().endPoint() + "tabu/SaveBCSValuation", request);
}
exports.submitBCSValuation = submitBCSValuation;
function submitOwnerShipChangeRequest(request) {
    return (0, rest_1.httpPost)(config_1.default.tabuAPI().endPoint() + "tabu/SaveOwnershipProcedure", request);
}
exports.submitOwnerShipChangeRequest = submitOwnerShipChangeRequest;
function submitPropertyCutOffRequest(request) {
    return (0, rest_1.httpPost)(config_1.default.tabuAPI().endPoint() + "tabu/SaveCutOffProcedure", request);
}
exports.submitPropertyCutOffRequest = submitPropertyCutOffRequest;
function submitDelayedPropertyCutOffRequest(request) {
    return (0, rest_1.httpPost)(config_1.default.tabuAPI().endPoint() + "tabu/SaveDelayedCutOffProcedure", request);
}
exports.submitDelayedPropertyCutOffRequest = submitDelayedPropertyCutOffRequest;
function submitPropertyAnnexRequest(request) {
    return (0, rest_1.httpPost)(config_1.default.tabuAPI().endPoint() + "tabu/SaveAnnexProcedure", request);
}
exports.submitPropertyAnnexRequest = submitPropertyAnnexRequest;
function submitDelayedPropertyAnnexRequest(request) {
    return (0, rest_1.httpPost)(config_1.default.tabuAPI().endPoint() + "tabu/SaveDelayedAnnexProcedure", request);
}
exports.submitDelayedPropertyAnnexRequest = submitDelayedPropertyAnnexRequest;
function base64ToArrayBuffer(base64) {
    var binaryString = base_64_1.default.decode(base64);
    var len = binaryString.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
}
